/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Drawer, DropdownButton, FilledButton, Menu } from '@neo4j-ndl/react';
import { useRef, useState } from 'react';

const Component = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const referenceElementRef = useRef<HTMLButtonElement | null>(null);

  return (
    <div className="n-h-[calc(40vh-32px)] n-min-h-[700px] n-flex n-relative n-overflow-hidden">
      <Drawer
        type="modal"
        isExpanded={isExpanded}
        onExpandedChange={() => setIsExpanded(false)}
        position="left"
        closeOnEscape={true}
        ariaLabel="Drawer"
        htmlAttributes={{
          id: 'drawer',
        }}
      >
        <Drawer.Header>Drawer</Drawer.Header>
        <Drawer.Body>
          Lorem ipsum dolor sit amet.{' '}
          <DropdownButton ref={anchorRef} onClick={() => setIsMenuOpen(true)}>
            Dropdown Button
          </DropdownButton>
          <Menu
            strategy="fixed"
            portalTarget={document.getElementById('drawer')}
            anchorRef={anchorRef}
            isOpen={isMenuOpen}
            onClose={(_event) => {
              setIsMenuOpen(false);
            }}
          >
            <Menu.Item title="Menu Item 1" />
            <Menu.Item title="Menu Item 2" />
            <Menu.Item title="Menu Item 3" />
          </Menu>
        </Drawer.Body>
        <Drawer.Actions>
          <FilledButton onClick={() => setIsExpanded(false)} size="medium">
            Close
          </FilledButton>
        </Drawer.Actions>
      </Drawer>
      <div className="n-size-full n-flex n-flex-col n-items-center n-justify-center n-rounded-md n-p-token-16 w-full">
        <div className="n-border-dashed n-border-2 n-border-light-primary-bg-strong n-size-full n-flex n-flex-col n-items-center n-justify-center n-rounded-md">
          <FilledButton
            onClick={() => setIsExpanded(true)}
            htmlAttributes={{
              'aria-expanded': isExpanded,
            }}
            ref={referenceElementRef}
          >
            Press to show the Drawer
          </FilledButton>
        </div>
      </div>
    </div>
  );
};

export default Component;
